module.exports = __webpack_public_path__ + "img/Comic05-3.89122428.png";